// extracted by mini-css-extract-plugin
module.exports = {"gridRow":"styles_gridRow__rp0L4","title":"styles_title__nCqDt","valueWrapper":"styles_valueWrapper__nVqtj","rawData":"styles_rawData__z4Y3F"};